import type { Restaurant } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { getRestaurantHistory } from "@/graphql/queries";

const client = generateClient();

export const historyRestaurantsState = create<State<Restaurant[]>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getHistoryRestaurantsIsloading = () =>
  historyRestaurantsState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const getHistoryRestaurantsIsError = (error: Error) =>
  historyRestaurantsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const getHistoryRestaurantsIsSuccess = (queryResult: Restaurant[]) =>
  historyRestaurantsState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const getHistoryRestaurants = async () => {
  getHistoryRestaurantsIsloading();

  try {
    const { data } = await client.graphql({
      query: getRestaurantHistory,
    });

    getHistoryRestaurantsIsSuccess(data.getRestaurantHistory as Restaurant[]);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to query getRestaurantHistory";
    getHistoryRestaurantsIsError(Error(errorMessage));
  }
};
